//TODO: Reimplement accordion as a composable

import classNames from 'classnames'
import { useState, useRef } from 'react'
import WidgetWrapper from './WidgetWrapper'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import noop from '@/root/utils/noop'
import Text from '@/stories/components/Common/NewText'

export type AccordionProps = {
  children: React.ReactNode
  title?: string | JSX.Element
  isOpen?: boolean
  arrow?: boolean
  logoUrl?: string
  shouldExpand?: boolean
  isFAQ?: boolean
  wrapperClass?: string
  arrowWrapperClass?: string
  titleClass?: string
  onClick?: () => void
  hTag?: 'h3' | 'h4' | 'div' | 'h2'
  buttonClass?: string
  maxHeight?: number
  subtitle?: string
}

const Accordion = ({
  children,
  title,
  isOpen = false,
  shouldExpand = true,
  arrow = true,
  logoUrl,
  isFAQ,
  wrapperClass = '',
  arrowWrapperClass = '',
  onClick = noop,
  titleClass = 'inline-block font-normal text-base text-left mb-0',
  hTag = 'h4',
  buttonClass = '',
  maxHeight,
  subtitle,
}: AccordionProps) => {
  const contentSpace = useRef<HTMLInputElement | null>(null)
  const [active, setActive] = useState(isOpen)
  const [height, setHeight] = useState(
    active
      ? `${maxHeight ? maxHeight : contentSpace.current?.scrollHeight}px`
      : '0px',
  )
  const [rotate, setRotate] = useState(
    active
      ? 'transform duration-300 ease rotate-180'
      : 'transform duration-300 ease',
  )

  function toggleAccordion() {
    if (shouldExpand) {
      setActive(active => !active)
      setHeight(
        active
          ? '0px'
          : `${maxHeight ? maxHeight : contentSpace.current?.scrollHeight}px`,
      )
      setRotate(
        active
          ? 'transform duration-300 ease'
          : 'transform duration-300 ease rotate-180',
      )
    }
  }

  return (
    <WidgetWrapper shadowClass={classNames('shadow-one', wrapperClass)}>
      <div className="flex flex-col">
        <button
          className={classNames(
            'box-border flex cursor-pointer appearance-none items-center justify-between',
            buttonClass,
          )}
          onClick={() => {
            onClick()
            toggleAccordion()
          }}
        >
          <div className="flex flex-col md:flex-row md:items-baseline md:gap-2">
            <div className="flex items-center gap-2">
              {logoUrl && (
                <div className="flex w-[20px] shrink-0 grow-0 items-center">
                  <StencilCDNImage
                    className="inline-block"
                    src={logoUrl}
                    width={20}
                    height={20}
                    alt="Payment Mode Icon"
                  />
                </div>
              )}
              {hTag === 'h3' ? (
                <h3
                  className={titleClass}
                  {...(isFAQ ? { itemProp: 'name' } : {})}
                >
                  {title}
                </h3>
              ) : hTag === 'div' ? (
                <div
                  className={titleClass}
                  {...(isFAQ ? { itemProp: 'name' } : {})}
                >
                  {title}
                </div>
              ) : hTag === 'h2' ? (
                <h2
                  className={titleClass}
                  {...(isFAQ ? { itemProp: 'name' } : {})}
                >
                  {title}
                </h2>
              ) : (
                <h4
                  className={titleClass}
                  {...(isFAQ ? { itemProp: 'name' } : {})}
                >
                  {title}
                </h4>
              )}
            </div>
            {subtitle && (
              <Text appearance="caption" addClassName="text-brand-grey-base">
                {subtitle}
              </Text>
            )}
          </div>
          {arrow && (
            <div
              className={classNames(
                'inline-block w-6 min-w-[24px]',
                rotate,
                arrowWrapperClass,
              )}
            >
              <ArrowDown />
            </div>
          )}
        </button>
        <div
          ref={contentSpace}
          style={{ maxHeight: `${height}` }}
          className="transition-max-height overflow-hidden duration-300 ease-in-out"
        >
          {children}
        </div>
      </div>
    </WidgetWrapper>
  )
}
export default Accordion
